import React from 'react';
import GlobalContext from '../../GlobalContext';
import QuoteRequestForm, { BrochureBtn, ImgRender } from '../../BFComponents';

const CanonDRC225 = () => {
    const paths = GlobalContext().paths;
    const pictures = paths.pictures;

    return (
        <div className="container">
            <div className="row justify-content-end">
                <div className="col-md-4 align-self-end">
                    <div className="d-flex justify-content-end">
                        <img id="canon-red-img" src={pictures + "canon-logo-red.svg"}></img></div>
                    <img src={pictures + "imageformula101.svg"}></img>
                </div>
            </div>
            <span className="display-4">Optional Flatbed Scanner</span>
            <div id="drc-banner-div">
                <ImgRender
                    width={100}
                    image={"drc225main.jpg"}
                />
            </div>
            <div className="row drc-after-btn">
                <div className="col-md-6"><strong className="drc225blue">The ultimate workgroup convenience.<br /></strong>
                Here’s the ideal way to scan bound, fragile or outsize
                documents. Plug-and-go simplicity plus easy operation
                make it the perfect flatbed scanner to share in and across
                departments – and it’s easy to store when not in use.
                <strong className="drc225blue"><br />Drive up productivity.<br /></strong>

                You can speed up processing with continuous ‘open
                scanning’ thanks to the unique ambient light cancelling
                mode; and with scanning speeds of under three seconds
                to scan an A4 page, the Flatbed Scanner Unit 101 helps
                teams work up to 50% more productively than many
                competitors’ products.
                <strong className="drc225blue"><br />High performance as standard.<br /></strong>

                The Flatbed Scanner Unit 101 has a high optical
                resolution of 1200dpi and provides access to a host of
                advanced image processing features. So you’re assured
premium quality results scan after scan.</div>
                <div className="col-md-6">
                    <QuoteRequestForm source={window.location} />
                    <BrochureBtn brochure={"SCANNER--CANON DR-C225 II Flatbed 101 Option.pdf"} />

                    <strong className="drc225blue">Outstanding features and benefits include:<br /></strong>
                    <ul>
                        <li>
                            Simple USB connection to a wide range of DR-series
                            scanners
                        </li>
                        <li>
                            High-speed capture gives up to 50% greater
                            productivity
                        </li>
                        <li>
                            A unique ambient light cancelling mode for rapid
                            open scanning
                        </li>
                        <li>
                            Capture documents as large as Legal size
                        </li>
                        <li>
                            A flexible cover takes the strain out of scanning bulky
                            volumes
                        </li>
                        <li>
                            A seamless interface with imageFORMULA devices for
                            dual capture
                        </li>
                        <li>
                            Access to the DR-series’ powerful image processing
                            features
                        </li>
                        <li>
                            Easily stowed away when not in use
                        </li>
                        <li>
                            Compliance with ENERGY STAR standards for lower
                            running cost
                        </li>
                    </ul>


                </div>
            </div>
        </div>
    )
}

export default CanonDRC225;